import * as actionTypes from './selfDiagnosisActionTypes';
import { RESET_STATE } from './selfDiagnosisActionTypes';

export function getSymptoms() {
  return { type: actionTypes.GET_SYMPTOMS };
}

export function diagnoseDisease() {
  return { type: actionTypes.DIAGNOSE_DISEASE };
}

export function setStepOneSelectedDiseases(data) {
  return { type: actionTypes.SET_STEP_ONE_SELECTED_DISEASE, data };
}

export function setDisease(data) {
  return { type: actionTypes.SET_DISEASE, data };
}

export function resetState() {
  return { type: actionTypes.RESET_STATE };
}

export function setActiveState(data) {
  return { type: actionTypes.SET_ACTIVE_STATE, data };
}
